import classNames from "../../_snowpack/pkg/classnames.js";
import React from "../../_snowpack/pkg/react.js";
import {LoadingSpinner} from "./LoadingSpinner.js";
export const LoadingPage = ({className}) => /* @__PURE__ */ React.createElement(LoadingSpinner, {
  className: classNames(className, "bg-white dark:bg-gray-900")
});
